import React from "react"
import Spinner from "react-bootstrap/Spinner"
import { Check, Pencil, X } from "lucide-react"

/**
 * @param {{
 *   state?: "idle" | "saving" | "success" | "error",
 *   onClick?: () => void,
 *   disabled?: boolean,
 *   className?: string,
 * }} props
 */
export default function EditActionIconButton({
    state = "idle",
    onClick = () => {},
    disabled = false,
    className = "",
}) {
    function icon() {
        switch (state) {
        case "saving":
            return <Spinner animation="border" size="sm" />
        case "success":
            return <Check size={14} />
        case "error":
            return <X size={14} />
        case "idle":
        default:
            return <Pencil size={14} />
        }
    }

    function textClass() {
        switch (state) {
        case "success":
            return "text-success"
        case "error":
            return "text-danger"
        default:
            return "text-primary"
        }
    }

    return (
        <button
            type="button"
            className={`btn btn-link btn-sm p-0 ms-2 ${textClass()} ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            {icon()}
        </button>
    )
}
